import React from 'react';
import Typed from 'react-typed';
import Bounce from 'react-reveal/Bounce';
import Slide from 'react-reveal/Slide';
import { useMobile } from '../../queries';
import './stars.css';
import StyledGhostButton from './GhostButton.style';
import FloatingCard3D from './FloatingCard3D';
import StyledFloatingCards from './FloatingCardsWrapper.style';
import StarTitle from './StarTitle';
import SectionTitle from '../../../SectionTitle.style';
import FloatingCard from './FloatingCard';
import { scrollToTop } from '../../../ScrollToTop';

// const mediaQuery = window.matchMedia('(max-width: 700px)');

const Stars = React.forwardRef(({ scrollToVideos }, ref) => {
  const isMobile = useMobile();
  return (
    <>
      <div className="cont" ref={ref}>
        <div id="stars" />
        <div id="stars2" />
        <div id="stars3" />
        <div style={{ marginTop: '50px' }}>
          <Bounce top>
            <StarTitle text="shapira bros" />
            <br />
            <StarTitle text="productions" />
          </Bounce>
        </div>
        <div id="title">
          <span>
        We do
            {' '}
            {isMobile && <br />}
          </span>
          <Typed
            strings={['Fashion', 'Music Videos', 'Commercials']}
            typeSpeed={60}
            backSpeed={50}
            loop
            backDelay={1000}
            style={{ color: 'orange' }}
          />
        </div>
        <div style={{ textAlign: 'center', paddingTop: '50px' }}>
          <StyledGhostButton to="/about" onClick={scrollToTop(false)}> About Us </StyledGhostButton>
        </div>
        <SectionTitle>Our Work</SectionTitle>
        <StyledFloatingCards>
          <Slide left>
            {isMobile ? <FloatingCard url="../img/stars1.jpg" cardText="MUSIC VIDEOS" onClick={scrollToVideos} /> : <FloatingCard3D url="../img/stars1.jpg" cardText="MUSIC VIDEOS" onClick={scrollToVideos} />}
          </Slide>
          <Slide right>
            {isMobile ? <FloatingCard url="../img/stars2.jpg" cardText="COMMERCIALS" onClick={scrollToVideos} /> : <FloatingCard3D url="../img/stars2.jpg" cardText="COMMERCIALS" onClick={scrollToVideos} />}
          </Slide>
        </StyledFloatingCards>
      </div>
    </>
  );
});

export default Stars;
